<template>
	<div id="login" class="body">
		<!--<img src="img/tubiao-09.png" class="logo" />-->
		<p class="logo">logo</p>
		<div class="body_count">
			<div class="login_count">
				<div class="login_count_a">
					<div id="all">
						<ul id="option">
							<li class="login_left">账号登录</li>
						</ul>
						<ul id="card">
							<li class="active">
								<!--输入框-->
								<div class="login_bot_count">
									<img src="img/tubiao-07.png" alt="" />
									<input v-model="user.username"  placeholder="请输入账号" id="one" />
								</div>
								<div class="login_bot_count">
									<img src="img/tubiao-06.png" alt="" />
									<input type="password" v-model="user.password" placeholder="请输入密码" id="one" />
								</div>
								<div class="login_bot">
									<a @click="jhmm">忘记密码?</a>
									<p @click="jumpTo">没账号？去注册</p>
								</div>
								<!--登录按钮-->
								<button @click="tologin" class="login_button">登录</button>
							</li>
						</ul>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data(){
			return{
				user:{
					username:'',
					password:''
				}
			}
		},
		methods: {
			jumpTo() {
				//指定跳转的地址
				this.$router.replace('/register')
			},
			jhmm(){
				this.$router.replace('/changePassword')
			},
			async tologin(){
			  let res = await http.post('api/login/login', {
			  	username: this.user.username,
			  	password: this.user.password
			  })
			  console.log(res)
			  sessionStorage.setItem('token', JSON.stringify(res.data.data.token))
			  sessionStorage.setItem('user', JSON.stringify(res.data.data.user))
			  if (res.data.msg == 'success') {
			  	this.logintrue = !this.logintrue
			  	const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
			  	let res = await http.get('api/picture/grzx', {
			  		uid: loginInfo.id
			  	})
			  	this.wcnmlgb = res.data.data[0]
				this.$router.replace('/')
			  } else {
			  	alert(res.data.msg)
			  }
			}
		}
	}
</script>
<style speed>
	* {
		margin: 0px;
		padding: 0px;
		text-decoration: none;
		list-style: none;
		outline: none;
		box-sizing: border-box;
	}

	.body {
		/* background: url(../img/beijing1.png) no-repeat; */
		background-image: url(../../imges/123cf0ee9.jpg);
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		background-size: 100% 100%;
		position: absolute;
	}

	.logo {
		height: 45px;
		margin: 20px 40px;
		font-size: 30px;
		color: white;
	}

	.img_l {
		position: fixed;
		width: 40%;
		top: 25%;
		left: 15%;
	}

	.body_count {
		width: 340px;
		position: fixed;
		top: 20%;
		left: 41%;
	}

	.body_count_top {
		width: 100%;
		text-align: center;
		color: white;
		font-size: 22px;
		font-weight: bold;
		letter-spacing: 8px;
	}

	#login .login_count {
		width: 340px;
		height: 380px;
		padding: 10px;
		background-color: white;
		border-radius: 10px;
		box-shadow: 0px 0px 15px #2aa2a3;
		margin-top: 20px;
	}

	.login_count_a {
		width: 100%;
	}

	.login_count_a_l {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
	}

	.icon_e {
		height: 18px;
	}

	.login_a_l_t {
		color: white;
		font-size: 12px;
		padding: 3px;
		background: linear-gradient(to right, #26CBD6, #3EE1E2);
	}

	.triangle {
		float: left;
		width: 0;
		height: 0;
		border-width: 11px;
		border-style: solid;
		border-color: transparent #3EE1E2 transparent transparent;
		transform: rotate(180deg);
	}

	#all {
		width: 80%;
		margin: 50px auto 0px;
	}

	#option {
		width: 100%;
		height: 40px;
		line-height: 40px;
		border-radius: 20px;
		border: 1px solid #ceffff;
		margin-bottom: 40px;
	}

	#option li {
		float: left;
		text-align: center;
		width: 100%;
		/*background: white;*/
		height: 38px;
		cursor: pointer;
		color: #4f4f4f;
		font-size: 16px;
		border-radius: 20px;
		font-weight: bold;
	}

	#option li.active {
		background: linear-gradient(to left, #40E4E5, #28CCD6);
		color: white;
		border-radius: 20px;
	}

	#card li {
		height: 100%;
		display: none;
	}

	#card li.active {
		display: block;
	}

	.login_bot_count {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_bot_count>img {
		height: 20px;
		padding-left: 5px;
	}

	.login_bot_count>input {
		height: 35px;
		border: 0px;
		width: 80%;
	}

	.login_bot_count>input::-webkit-input-placeholder {
		color: #dedede;
	}

	.login_bot {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
	}

	.login_bot>a,
	.login_bot>p {
		font-size: 12px;
		color: #898989;
	}

	.login_bot>p {
		width: 33%;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
	}


	/*记住密码勾选框*/

	.login_bot>p>input[type="checkbox"] {
		width: 10px;
		height: 10px;
		display: inline-block;
		text-align: center;
		vertical-align: middle;
		line-height: 10px;
		position: relative;
	}

	.login_bot>p>input[type="checkbox"]::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		background: #fff;
		width: 100%;
		height: 100%;
		border: 1px solid #dedede;
	}

	.login_bot>p>input[type="checkbox"]:checked::before {
		content: "\2713";
		background-color: white;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		border: 1px solid #dedede;
		color: #898989;
		font-size: 12px;
		font-weight: bold;
	}


	/*按钮样式*/

	.login_button {
		margin-top: 20px;
		width: 100%;
		border: 0px;
		height: 35px;
		font-size: 16px;
		color: white;
		background: linear-gradient(to left, #40E4E5, #28CCD6);
	}

	.login_account_count {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_account_count>img {
		height: 20px;
		padding-left: 5px;
	}

	.mobile_input {
		height: 35px;
		border: 0px;
		width: 75%;
	}

	.account_select {
		color: #4F4F4F;
		font-size: 14px;
		border: 0px;
		margin: 0px 5px;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		width: 45px;
		z-index: 999;
		background: none;
	}

	.account_select_icon {
		position: relative;
		left: -8%;
		height: 10px !important;
	}

	.login_account_counts {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_account_counts>img {
		height: 20px;
		padding-left: 5px;
	}

	.login_account_counts>input:nth-of-type(1) {
		height: 35px;
		border: 0px;
		width: 50%;
	}

	.account_code {
		color: white;
		background-color: #26CBD6;
		padding: 5px;
		font-size: 12px;
		cursor: pointer;
		border: 0px;
	}

	.login_account_count>input::-webkit-input-placeholder {
		color: #dedede;
	}

	.login_account_counts>input::-webkit-input-placeholder {
		color: #dedede;
	}


	/*按钮样式*/

	.login_account_button {
		margin-top: 40px;
		width: 100%;
		border: 0px;
		height: 35px;
		font-size: 16px;
		color: white;
		background: linear-gradient(to left, #40E4E5, #28CCD6);
	}

	.login_count_b {
		width: 100%;
		display: none;
	}

	.login_count_b_l {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
	}

	.icon_e,
	.icon_z {
		height: 18px;
	}

	.login_b_l_t {
		color: white;
		font-size: 12px;
		padding: 3px;
		background: linear-gradient(to right, #26CBD6, #3EE1E2);
	}

	.login_b_title>img {
		height: 22px;
		margin-right: 5px;
	}

	.login_b_title {
		width: 100%;
		margin-top: 30px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: black;
		font-size: 16px;
		font-weight: 1000;
	}

	.libqr {
		width: 60%;
		margin: 10px 20%;
	}

	.libqr_text {
		width: 100%;
		text-align: center;
		color: #c4c4c4;
		font-size: 12px;
	}

	.delivery_count_l_b>input:focus .delivery_count_l_b {
		border-bottom: 1px solid #26CAD6;
	}
</style>
